/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import Moment from 'moment';
import 'moment/locale/it.js';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';

const optionsIntervals = [
    { key: '7', text: 'Ultimi 7 giorni', value: '7' },
    { key: '30', text: 'Ultimi 30 giorni', value: '30' },
    { key: '90', text: 'Ultimi 90 giorni', value: '90' },
    { key: '180', text: 'Ultimi 180 giorni', value: '180' },
    { key: '365', text: 'Ultimo anno', value: '365' },
]

const optionsSpecs = [
    { key: 'i', text: 'Da inizio anno ad oggi', value: 'i' },
    { key: 'p', text: 'Intervallo personalizzato', value: 'p' },
]

class DataFilter extends Component {
    constructor(props) {
        super(props);
        let fields = {tipo: props.tipo, showOption: props.showOption}
        if (props.dataDal !== undefined && props.dataAl !== undefined){
            fields = Object.assign(fields, {dataDal: props.dataDal, dataAl: props.dataAl});
        }
        this.updateDataFields(fields, 'tipo', props.tipo);
        this.state = {fields};
        this.onInputChange = this.onInputChange.bind(this);

    }
    componentWillReceiveProps(nextProps){
        let fields = this.state.fields;
        fields.tipo = nextProps.tipo;
        fields.dataDal = nextProps.dataDal;
        fields.dataAl = nextProps.dataAl;
        fields.showOption = nextProps.showOption;
        this.setState({fields});
    }

    componentDidMount(){
        if (this.props.fireOnChangeOnStart){
            this.props.onChange(this.state.fields.tipo, this.state.fields.dataDal, this.state.fields.dataAl);
        }
    }

    onInputChange(a1, {name, value}) {
        if (name !== undefined)
        {
            const fields = this.state.fields;
            //fields[name] = value;
            fields[name] = Moment(value).format("YYYY-MM-DD");
            this.updateDataFields(fields, name, value);
            this.setState({ fields });
            this.props.onChange(this.state.fields.tipo, this.state.fields.dataDal, this.state.fields.dataAl);
        }
    }
    updateDataFields(fields, name, value){
        if (name === 'tipo') {
            if (value === 'i'){
                fields.dataDal = Moment().format("YYYY") + '-01-01';
                fields.dataAl = Moment().format("YYYY-MM-DD");
            }
            else if (value !== 'p'){
                fields.dataDal = Moment().subtract(value, 'days').format("YYYY-MM-DD");
                fields.dataAl = Moment().format("YYYY-MM-DD");
            }
        }
    }
    render() {

        let options = [];
        if (this.state.fields.showOption === 'intervals'){
            options = optionsIntervals;
        } else if (this.state.fields.showOption === 'specs'){
            options = optionsSpecs;
        } else {
            options = options.concat(optionsIntervals, optionsSpecs);
        }

        let ddTipo = null;
        if (this.props.showTipo){
            ddTipo = (<Form.Dropdown name='tipo' fluid selection options={options} value={''+this.state.fields.tipo} onChange={this.onInputChange}/>)
        }

        return (
            <div className="ui form">
                <div className="inline fields">

                    {ddTipo}

                    <Form.Field>
                        <label>dal</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'dataDal', value: dateString})}}
                            value={this.state.fields.dataDal}
                            className="ui input"
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>al</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'dataAl', value: dateString})}}
                            value={this.state.fields.dataAl}
                            className="ui input"
                        />
                    </Form.Field>
                </div>
            </div>
        )
    }
}

DataFilter.PropTypes = {
    tipo: PropTypes.string.isRequired,
    dataDal: PropTypes.string,
    dataAl: PropTypes.string,
    showOption: PropTypes.oneOf([
        'all', 'intervals', 'specs'
    ]),
    fireOnChangeOnStart: PropTypes.bool,
    showTipo: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

DataFilter.defaultProps = {
    tipo: '7',
    showOption: 'all',
    fireOnChangeOnStart: false,
    showTipo: true,
};
export default DataFilter;



/** WEBPACK FOOTER **
 ** ./src/components/DataFilter.js
 **/